'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_c052660e = {"container":"Dropdown_module_container__1b35c268","dropdown":"Dropdown_module_dropdown__1b35c268","trigger-element":"Dropdown_module_triggerElement__1b35c268","disabled":"Dropdown_module_disabled__1b35c268","menu":"Dropdown_module_menu__1b35c268"};
require("../../../assets/cjs/components/Dropdown/src/Dropdown~cB864hLx.css");

exports.default = modules_c052660e;
//# sourceMappingURL=Dropdown.module.less.js.map
